<!-- @format -->

<template>
  <div class="ly-c-menu">
    <div class="menu-top">
      <svg-icon class="logo" icon-class="icon_logo"></svg-icon>
      <!-- <div class="logo" :class="longTitleFlag ? 'long' : ''">
        <img
          class="img"
          :src="
            appBasicData && appBasicData.sysLogo2Url
              ? appBasicData.sysLogo2Url
              : logoImg
          "
        />
        <p class="sys-title" v-if="!isCollapse">
          <span
            :style="
              sysBasicTitle&&sysBasicTitle.length < 8
                ? { 'min-width': '100%', display: 'inline-block' }
                : {}
            "
            >{{ sysBasicTitle }}</span
          >
          <span>{{ platTitle }}</span>
        </p>
      </div>
     <span class="logo-text" style="opacity: 0">{{ sysBasicTitle }}</span> -->
    </div>
    <slot name="prepend"></slot>
    <el-scrollbar class="ly-c-scroll" :class="{ 'no-transition': !isCollapse }">
      <el-menu
        ref="menuRef"
        router
        :collapse="isCollapse"
        :default-active="activePath"
        :default-openeds="defaultOpenPath"
        :class="{ change: isMenuChange }"
        @open="menuOpen"
        @close="menuClose"
      >
        <NavMenu
          :key="activePath"
          @getMenu="getMenu"
          :menuList="menuList"
          :defaultProps="menuProp"
          :collapse="isCollapse"
          :textShow="textShow"
          :isTooltip="isTooltip"
        >
          <template v-slot:menuItem="scope">
            <slot
              name="menu-item"
              :data="{ ...scope.data, ...{ collapse: isCollapse } }"
            ></slot>
          </template>
        </NavMenu>
      </el-menu>
    </el-scrollbar>
    <!-- <div class="menu-collapse-icon" @click="menuCollapse">
      <i class="el-icon-s-fold"></i>
    </div> -->
    <div class="menu-user ly-c-flex column">
      <!-- <el-avatar
        shape="square"
        size="medium"
        :src="squareUrl"
      ></el-avatar> -->
      <!-- <div
        class="ly-c-flex"placement="top-end"
      > -->
      <!-- <el-dropdown trigger="click">
        <p class="title">
          <span class="user-name">{{ userName }}</span>
          <i class="el-icon-caret-bottom"></i>
        </p>

        <el-dropdown-menu slot="dropdown" class="menu-dropdown">
          <el-dropdown-item command="logOut" @click.native="userLogout()"
            >退出登录</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown><el-dropdown trigger="click">
        <p class="title">
          <span class="user-name">{{ userName }}</span>
          <i class="el-icon-caret-bottom"></i>
        </p>

        <el-dropdown-menu slot="dropdown" class="menu-dropdown">
          <el-dropdown-item command="logOut" @click.native="userLogout()"
            >退出登录</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import NavMenu from "./NavMenu";
import auth from "../../scripts/auth";
import { mapGetters } from "vuex";
import request from "../../scripts/request";
export default {
  name: "SideBar",
  components: {
    NavMenu,
  },
  props: {
    isTooltip: {
      //超长时是否省略
      type: Boolean,
      default: true,
    },
    isMenuChange: {
      // 是否切换菜单样式
      type: Boolean,
      default: false,
    },
    sysTitle: {
      type: String,
      default: "智慧管理中台",
    },
    platTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      activePath: "/layout",
      isCollapse: false,
      textShow: true,
      menuProp: {
        path: "routeAddress",
        icon: "icon",
        name: "name",
        children: "childList",
      },
      defaultOpenPath: [],
      themeValue: "2D4CD3",
      logoImg: require("../../assets/images/logo.svg"),
      logoCollapseImg: require("../../assets/images/menu_bag.png"),
      logoTitle: this.title,
      longTitleFlag: false,
      squareUrl: "",
      isDropdown: false,
      userName: "",
    };
  },
  computed: {
    ...mapGetters(["menuList", "appBasicData"]),
  },
  watch: {
    $route(to) {
      // this.$forceUpdate();
      this.setMenuActive(to);
    },
  },
  created() {
    this.userName = auth.getUserInfo().username;
    this.defaultOpenPath = this.getDefaultOpen();
    this.setMenuActive(this.$route);
  },
  mounted() {},
  methods: {
    handleCommand(val) {
      console.log("handleCommand.val:", val);
    },
    setMenuActive(route) {
      let pathArray = [];
      let path = null;
      // let catalogName="";
      path = route.path.match(/\/\w+/g) || [];
      path.forEach((val, index) => {
        pathArray.push(index === 0 ? val : pathArray[index - 1] + val);
      });
      this.activedMenu(this.menuList, pathArray);
    },
    /**
     * 左侧菜单栏当前选中的菜单
     * @param menu 用户菜单列表，即左侧菜单栏数据
     * @param arr 当前路由根据/分割出来的数组
     */
    activedMenu(menu, arr) {
      menu.filter((item) => {
        if (arr.includes(item[this.menuProp.path])) {
          this.activePath = item[this.menuProp.path];
        }
        if (
          item[this.menuProp.children] &&
          item[this.menuProp.children].length > 0
        ) {
          this.activedMenu(item[this.menuProp.children], arr);
        }
      });
    },
    getDefaultOpen() {
      let path = this.activePath;
      let new_path = null;
      let pathArray = [];
      let defaultOpened = [];
      new_path = path.match(/\/\w+/g);
      new_path.forEach((val, index) => {
        pathArray.push(index === 0 ? val : pathArray[index - 1] + val);
      });
      defaultOpened.push(pathArray[0]);
      return defaultOpened.concat(this.defaultOpenPath);
    },
    menuOpen(index) {
      this.defaultOpenPath.push(index);
    },
    menuClose(index) {
      this.defaultOpenPath = this.defaultOpenPath.filter(
        (item) => item != index
      );
    },
    getMenu() {
      this.$emit("getMenu");
    },
    menuCollapse() {
      let opens = JSON.parse(JSON.stringify(this.defaultOpenPath));
      this.defaultOpenPath = [];
      this.textShow = !this.textShow;
      setTimeout(() => {
        this.isCollapse = !this.isCollapse;
      }, 0);
      this.defaultOpenPath = opens;
    },
    //退出登录
    userLogout() {
      request({
        url: "/auth/oauth/logout",
        method: "get",
      }).then((res) => {
        if (res.code === "00000") {
          // auth.removeAllSession();
          // auth.goLogin();
          this.$router.push({
            path: "/login",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/ly-menu.scss";
</style>
<style lang="scss" scoped>
.menu-top {
  justify-content: center;
  .logo {
    font-size: 80px;
  }
}
/deep/ .el-dropdown {
  width: 100%;
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 28px 0 24px;
  }
}
</style>
